import { Fragment, useEffect } from "react";
import { useAuth } from "../../contexts/auth";
import Carregando from "../../pages/carregando";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { baseURLApp, useApi } from "../../contexts/api";
import { getURLWaymenu } from "../../utils/retornarURLWaymenu";

export function RedirectWaymenu() {
  const { getDadosEmpresa } = useAuth();
  const { realizarLogoff } = useApi();
  const navigate = useNavigate();
  let { tipo } = useParams();

  async function irParaCardapio() {
    let dadosEmpresaDTO = await getDadosEmpresa().catch((error) => {
      console.error(error);
      toast.error("Erro ao obter dados da empresa");
      if (error?.response?.status === 401) {
        realizarLogoff();
      } else {
        navigate("/");
      }
    });
    let urlAmigavel = dadosEmpresaDTO?.urlAmigavel;
    if (urlAmigavel) {
      let urlPagina = window.location.href;
      let url = getURLWaymenu(urlPagina, baseURLApp);
      if (!url) {
        toast.error("Falha ao obter a URL do Waymenu");
      } else {
        window.location.replace(`${url}/${urlAmigavel}/${tipo}/`);
      }
    } else {
      toast.error("url_amigavel não configurada");
      navigate("/");
    }
  }

  useEffect(() => {
    irParaCardapio();
  }, []);

  return (
    <Fragment>
      <Carregando />
    </Fragment>
  );
}
